/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Search_PlaceholderInputs */

const cs_settings_venues_search_placeholder = /** @type {(inputs: Settings_Venues_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název, slug nebo firma…`)
};

const en_settings_venues_search_placeholder = /** @type {(inputs: Settings_Venues_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, slug, or company…`)
};

/**
* | output |
* | --- |
* | "Name, slug, or company…" |
*
* @param {Settings_Venues_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_search_placeholder = /** @type {((inputs?: Settings_Venues_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_search_placeholder(inputs)
	return cs_settings_venues_search_placeholder(inputs)
});